import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import InputLabel from "@mui/material/InputLabel";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

import { useState } from "react";
import CodeIcon from "@mui/icons-material/Code";


import moment from "moment";
import { GlobalState } from "../../../context/GlobalContext";
import FileSaver from "file-saver";
import ResultTable from "../ResultTable";
import { pythonVmInstance } from "utils/AxiosInstances/RareboxPythonInstance";

const dateFieldSx = {
	minWidth: { xs: "100%", sm: 180 },
	"& .MuiOutlinedInput-root": {
		borderRadius: 1.5,
		bgcolor: "#fff",
		"& fieldset": { borderColor: "#e5e7eb" },
		"&:hover fieldset": { borderColor: "#d1d5db" },
		"&.Mui-focused fieldset": { borderColor: "#6b7280", borderWidth: 1 },
	},
};
const runButtonSx = {
	width: "fit-content",
	minWidth: 148,
	textTransform: "none",
	fontWeight: 600,
	borderRadius: 1.5,
	bgcolor: "#1f2937",
	px: 2.25,
	boxShadow: "none",
	"&:hover": { bgcolor: "#111827", boxShadow: "none" },
};
const downloadButtonSx = {
	textTransform: "none",
	fontWeight: 600,
	borderRadius: 1.5,
	borderColor: "#d1d5db",
	color: "#374151",
	boxShadow: "none",
	"&:hover": { borderColor: "#9ca3af", bgcolor: "#f9fafb", boxShadow: "none" },
};

const EboSoh = () => {
    const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();
    const [result, setResult] = useState([]);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();

    const handleGetGrn = async (e,action) => {
        e.preventDefault();
        try {
                let params = {
                    startDate,
                    endDate,
                    action
                };
                setLoadingOpen(true);
                await pythonVmInstance({
                    url: `/uc_vs_ginesys/ebo-soh`,
                    params: params,
                    headers: {
                        "Content-Type": "application/json",
                    },
                    method: "GET",
                    responseType: action =="get" ? "json" : "blob",
                }).then((res) => {
                    const data = res?.data?.result;
                    console.log("pythonVmInstance",res?.data?.result)
                    
                    if (action != "get") {
                        setResult([]);
                        const url = URL.createObjectURL(res.data);
                        FileSaver.saveAs(url, `${moment().format("YYYY-MM-DD")}_ebo_soh_uc_vs_ginesys.csv`);
                        setLoadingOpen(false);
                    }else{
                        setResult(data);
                        setLoadingOpen(false);
                    }
                });
            } catch (error) {
                setSnackBarOpen(true);
                setLoadingOpen(false);
                setSnackBar({
                    ...snackBar,
                    message: "Failed to download file",
                    severity: "error",
                    anchorOrigin: { horizontal: "center", vertical: "top" },
                });
            }
        };
    console.log(result, "result")
    return (
        <Stack spacing={2} component="form" onSubmit={(e) => handleGetGrn(e,"get")}>
            <Typography sx={{ fontWeight: 700, color: "#111827", fontSize: "1.05rem" }}>EBO SOH</Typography>
            <Box display="flex" columnGap={2} rowGap={2} flexWrap="wrap" alignItems="flex-end">
                <Stack spacing={1}>
                    <InputLabel sx={{ fontSize: "0.75rem", fontWeight: 600, color: "#6b7280" }}>Selected Date</InputLabel>
                    <TextField
                        size="small"
                        type="date"
                        value={moment().format("YYYY-MM-DD")}
                        onChange={(e) => setStartDate(e.target.value)}
                        required
                        disabled={true}
                        sx={dateFieldSx}
                    />
                </Stack>
            </Box>
            <Button
                variant="contained"
                sx={runButtonSx}
                type="submit"
                startIcon={<CodeIcon />}>
                    Run Query
            </Button>
         {result.length ? (
                // table
                <Box sx={{ width: "100%" }} pb={5}>
                    <Typography sx={{ fontWeight: 700, color: "#111827", fontSize: "1.05rem" }}>Result</Typography>
                    <Box display="flex" alignItems="center" flexWrap="wrap" gap={1.5} pt={2} pb={2}>
                        <Typography>
                            Raise To Ginesys From {moment(startDate).format("DD-MM-YYYY")} to{" "}
                            {moment(endDate).format("DD-MM-YYYY")}
                        </Typography>
                        <Button
                            onClick={(e) => handleGetGrn(e,"download")}
                            sx={downloadButtonSx}
                            variant="outlined">
                            Download
                        </Button>
                    </Box>
                     {result.length ? (
                        <ResultTable rows={result} />
                    ) : (
                        <Typography sx={{ color: "#b91c1c", fontSize: "0.875rem" }}>
                            No records to display
                        </Typography>
                    )}
                 </Box> 
             ) : ( 
                <></>
         )}
        </Stack>
    );
};

export default EboSoh;